import axios from '@/util/request'

const baseURL = process.env.VUE_APP_API_URL

export default {
  shoplineGetListings: data => axios({ baseURL, url: '/api/listings/shopline/listings', method: 'post', data }), // 获取listing列表
  shoplineListingStatus: data => axios({ baseURL, url: '/api/listings/shopline/listingStatus', method: 'put', data }), // 批量上架&上架&批量下架&下架
  shoplineListingDelete: data => axios({ baseURL, url: '/api/listings/shopline/listings', method: 'delete', data }), // 删除&批量删除Listing
  shoplineSyncListings: data => axios({ baseURL, url: '/api/listings/shopline/syncListings', method: 'post', data }), // 手动同步listing
  shoplineAdd: data => axios({ baseURL, url: '/api/listings/shopline/listing', method: 'post', data }), // listing新增
  shoplineEdit: data => axios({ baseURL, url: '/api/listings/shopline/listing', method: 'put', data }), // listing编辑
  shoplineGetDetail: params => axios({ baseURL, url: '/api/listings/shopline/listingDetail', method: 'get', params }), // 根据id获取listing详情
  shoplineSyncCollections: params => axios({ baseURL, url: '/api/listings/shopline/syncCollections', method: 'get', params }), // 同步Collection
  shoplineGetCollections: params => axios({ baseURL, url: '/api/listings/shopline/collections', method: 'get', params }) // 获取Collection
}
